import { FC, ReactElement, useContext, useEffect } from 'react'
import { useMedplum } from '@medplum/react'
import { useLDClient } from 'providers/launchdarklyHooks'
import { formatPrimaryName } from 'utils/names'
import FeatureFlagPatientContext from 'contexts/FeatureFlagPatientContext'

interface UserContextProviderProps {
  children: ReactElement
}

const FeatureFlagUserContextProvider: FC<UserContextProviderProps> = ({ children }) => {
  const ldClient = useLDClient()
  const medplum = useMedplum()
  const profile = medplum.getProfile()
  const profileName = formatPrimaryName(profile?.name) ?? ''
  const profileEmail = profile?.telecom?.find((t) => t.system === 'email')?.value
  const practitionerId = profile?.id
  const { patientId } = useContext(FeatureFlagPatientContext)

  useEffect(() => {
    if (ldClient && practitionerId && profileName && profileEmail) {
      if (patientId) {
        void ldClient.identify({
          kind: 'multi',
          user: {
            key: practitionerId,
            name: profileName,
            email: profileEmail,
            _meta: {
              privateAttributes: ['name', 'email']
            }
          },
          patient: {
            key: patientId
          }
        })
      } else {
        void ldClient.identify({
          kind: 'user',
          key: practitionerId,
          name: profileName,
          email: profileEmail,
          _meta: {
            privateAttributes: ['name', 'email']
          }
        })
      }
    }
  }, [practitionerId, ldClient, profileEmail, profileName, patientId])

  return children
}

export default FeatureFlagUserContextProvider
